<div class="edit-dt-root">
  <div class="edit-dt-header">
    <div class="dt-header-info">
      <div class="dt-info">
        <div class="name">{{'MV_POLES.EDIT.MV_SLRN' | translate}}</div>
        <div class="tag-customer" *ngIf="selectedMvPole.poleType">{{ 'COMMON.POLE.TYPE.' + selectedMvPole.poleType | uppercase | translate }} {{'COMMON.TYPE' | translate | lowercase}}</div>
        <div class="row">
          <div class="slrn col-7">
            {{ selectedMvPole.slrn ? selectedMvPole.slrn : ('COMMON.NO_SLRN' | translate) }}
          </div>
          <div class="col-2 pole-status complete-pole" *ngIf="
              selectedMvPole.dataQualityStatus!.toString() == 'Approved'
            ">
            {{'COMMON.ASSET_STATUS.COMPLETE' | translate}}
          </div>
          <div class="col-2 pole-status rejected-pole" *ngIf="
              selectedMvPole.dataQualityStatus!.toString() == 'Rejected'
            ">
            {{'COMMON.ASSET_STATUS.REJECTED' | translate}}
          </div>
          <div class="col-2 pole-status" *ngIf="selectedMvPole.status && 
              selectedMvPole.dataQualityStatus!.toString() !== 'Approved' &&
              selectedMvPole.dataQualityStatus!.toString() !== 'Rejected'"
              [ngClass]="{'pending-pole' : selectedMvPole.status == 'Pending',
                          'assigned-pole' : selectedMvPole.status == 'Assigned' || selectedMvPole.status == 'Retagged'}"> 
            {{ 'COMMON.ASSET_STATUS.' + selectedMvPole.status | uppercase | translate }} 
          </div>
        </div>
        </div>
         <div class="user-address">
        <div></div>
        <div>{{ selectedMvPole.address | hasValue }}</div>
        <div>{{ selectedMvPole.poleCondition | hasValue }}</div>
      </div>
    </div>
    <div class="action-buttons">
      <button class="btn btn-header" data-bs-toggle="modal" *ngIf="permissionsService.isMVPoleRetagAllowed"
        (click)="getMobileUsers(); setModalType(AssetAssignType.Retagged);" data-bs-target="#assignToFieldAgent">
        {{'COMMON.RETAG' | translate}}
      </button>

      <div class="recall-div" *ngIf="
          permissionsService.isMVPoleRecallAssignedAllowed ||
          permissionsService.isMVPoleRecallValidatedAllowed
        ">
        <button class="btn btn-header recall-button" style="color: black" (click)="showRecallMenu = !showRecallMenu">
          <span class="recall-span">{{'COMMON.RECALL' | translate}}</span>
        </button>
        <div *ngIf="showRecallMenu" class="recall-options">
          <div *ngIf="permissionsService.isMVPoleRecallAssignedAllowed" 
              class="recall-type" [ngClass]="[
              !recallAssignedAllowed
                ? 'recall-type-disabled'
                : 'recall-type-enabled'
            ]" (click)="recallAssignedAllowed ? recall() : null">
            <span>{{'COMMON.ASSIGNED_TASK' | translate}}</span>
          </div>
          <div *ngIf="permissionsService.isMVPoleRecallValidatedAllowed"
              class="recall-type" [ngClass]="[
              !recallValidatedAllowed
                ? 'recall-type-disabled'
                : 'recall-type-enabled'
            ]" (click)="recallValidatedAllowed ? recall() : null">
            <span>{{'COMMON.VALIDATED_TASK' | translate}}</span>
          </div>
        </div>
      </div>

      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#updateStatus"
        [disabled]="disableUpdateStatusButton()" *ngIf="permissionsService.isMVPoleApproveRejectAllowed">
        {{'COMMON.UPDATE_STATUS' | translate}}
      </button>

      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#auditReview"
        [disabled]="selectedMvPole.auditedStatus === 'Audited'" *ngIf="permissionsService.isMVPoleAuditReviewAllowed">
        {{'COMMON.FIELD_AUDIT' | translate}}
      </button>

      <button class="btn btn-header" data-bs-toggle="modal" data-bs-target="#assignToFieldAgent"
        (click)="getMobileUsers(); setModalType(AssetAssignType.Assigned);" *ngIf="permissionsService.isMVPoleAssignAllowed">
        {{'COMMON.ASSIGN_AGENT' | translate}}
      </button>

      <button class="btn btn-header" *ngIf="!editEnabled && permissionsService.isMVPoleCreateEditAllowed"
        (click)="edit()">
        {{'COMMON.EDIT' | translate}}
      </button>
      <button *ngIf="editEnabled" class="btn btn-primary"
        #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history">{{'COMMON.SAVE' | translate}}
      </button>
    </div>
  </div>

  <div class="edit-dt-body">
    <div class="main-col">
      <div class="card container">
        <div class="row">
          <div class="col-5">
            <p class="card-title">{{'MV_POLES.EDIT.MV_INFO' | translate}}</p>
          </div>
            <div class="col-7">
                <div class="line-2"></div>
            </div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.MV_ID' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.poleId | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.MV_NUMBER' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.poleNumber | hasValue }}</div>
          <input *ngIf="editEnabled" class="col-7" [(ngModel)]="selectedMvPole.poleNumber" />
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.MV_TYPE' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.poleType | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
              <select class="form-control" [(ngModel)]="selectedMvPole.poleType">
                  <option *ngFor="let option of mvPoleTypeOptions" [value]="option.name">
                      {{ option.translation | translate }}
                  </option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.SHAPE' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.poleShape | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
              <select class="form-control" [(ngModel)]="selectedMvPole.poleShape">
                  <option *ngFor="let option of mvPoleShapeOptions" [value]="option.name">
                      {{ option.translation | translate }}
                  </option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.CONDITION.TITLE' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.poleCondition | translate | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
              <select class="form-control" [(ngModel)]="selectedMvPole.poleCondition">
                  <option *ngFor="let option of mvPoleConditionOptions" [value]="option.name">
                      {{ option.translation | translate }}
                  </option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.STRUCTURE' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.poleStructure | translate | hasValue }}</div>
          <div *ngIf="editEnabled" class="col-7">
              <select class="form-control" [(ngModel)]="selectedMvPole.poleStructure">
                  <option *ngFor="let option of mvPoleStructureOptions" [value]="option.name">
                      {{ option.translation | translate }}
                  </option>
              </select>
          </div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.CROSS_ARM_COND' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.crossArmCondition | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.LV_RETICULATION' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.lvReticulation | hasValue }}</div>
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.ADDRESS' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.address | hasValue }}</div>
          <input *ngIf="editEnabled" class="col-7" [(ngModel)]="selectedMvPole.address" />
        </div>
        <div class="row">
          <div class="col-5">{{'MV_POLES.LANDMARK' | translate}}</div>
          <div *ngIf="!editEnabled" class="col-7">{{ selectedMvPole.landmark | hasValue }}</div>
          <input *ngIf="editEnabled" class="col-7" [(ngModel)]="selectedMvPole.landmark" />
        </div>
        <div class="row">
          <div class="locatonLabel col-5">{{'COMMON.MBC_DETAILS.GEO_LOCATION' | translate}}</div>
          <div class="locationText col-6">
            {{ selectedMvPole.latitude }}, {{ selectedMvPole.longitude }}
          </div>
          <div class="location col-1" (click)="isMapVisible = !isMapVisible">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 500 500"
              data-bs-toggle="modal"
              data-bs-target="#showMap"
            >
              <path
                d="M256 0c17.7 0 32 14.3 32 32V66.7C368.4 80.1 431.9 143.6 445.3 224H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H445.3C431.9 368.4 368.4 431.9 288 445.3V480c0 17.7-14.3 32-32 32s-32-14.3-32-32V445.3C143.6 431.9 80.1 368.4 66.7 288H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H66.7C80.1 143.6 143.6 80.1 224 66.7V32c0-17.7 14.3-32 32-32zM128 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128s-128 57.3-128 128zm128 80c-44.2 0-80-35.8-80-80s35.8-80 80-80s80 35.8 80 80s-35.8 80-80 80z"
                fill="#026962"
              />
            </svg>
          </div>
        </div>
  
        <div class="row">
        <div class="col-5">
          <p class="card-title">{{'MV_POLES.USER_ACTIVITY' | translate}}</p>
        </div>
        <div class="col-7">
          <div class="line-2"></div>
        </div>
      </div>
      <div class="row">
          <div class="col-5">{{'COMMON.USER.TYPE.FIRST_CAPTURED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.firstCapturedUser | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'COMMON.USER.TYPE.LAST_UPDATED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.lastUpdateUser | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'MV_POLES.CREATION_DATE' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.creationDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.UPDATED_DATE' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.lastUpdate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'COMMON.USER.TYPE.REASSIGNED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.reassignedBy | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'COMMON.MBC_DETAILS.ASSIGNED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.assignedUser | hasValue}}</div>
      </div>
        <div class="row" *ngIf="permissionsService.isValidationStatusAllowed">
          <div class="col-5">{{'COMMON.VALIDATION_STATUS' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.dataQualityStatus | hasValue}}</div>
      </div>
        <div class="row" *ngIf="permissionsService.isValidationStatusAllowed">
          <div class="col-5">{{'COMMON.USER.TYPE.VALIDATED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.validatedBy | hasValue}}</div>
      </div>
        <div class="row" *ngIf="permissionsService.isValidationStatusAllowed">
          <div class="col-5">{{'COMMON.DATE_TYPE.VALIDATED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.validationDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
      </div>
      <div class="row" *ngIf="permissionsService.isAuditStatusAllowed">
          <div class="col-5">{{'COMMON.MBC_DETAILS.AUDITED_STATUS' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.auditedStatus | hasValue}}</div>
      </div>
        <div class="row" *ngIf="permissionsService.isAuditStatusAllowed">
          <div class="col-5">{{'COMMON.USER.TYPE.AUDITED' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.auditedBy | hasValue}}</div>
      </div>
        <div class="row" *ngIf="permissionsService.isAuditStatusAllowed">
          <div class="col-5">{{'COMMON.MBC_DETAILS.AUDITED_DATE' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.auditedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
      </div>

       <div class="row">
        <div class="col-5">
          <p class="card-title">{{'COMMON.COMMENTS' | translate}}</p>
        </div>
        <div class="col-7">
          <div class="line-2"></div>
        </div>
      </div>
        <div class="row">
          <div class="col-5">{{'COMMON.COMMENT' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.comment | hasValue}}</div>
        </div>

      </div>
    </div> 

    <div class="card container main-col">
      <div class="row">
            <div class="col-5">
              <p class="card-title">{{'MV_POLES.NETWORK_INFO.MV_NETWORK_INFO' | translate}}</p>
            </div>
            <div class="col-7">
              <div class="line-2"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-5">{{'MV_POLES.NETWORK_INFO.TS' | translate}}</div>
            <div class="col-7">{{ (hasCimDataIntegration ? selectedMvPole.transmissionSubstationName : selectedMvPole.transmissionStation) | hasValue}}</div>
        </div>
        <div class="row">
            <div class="col-5">{{'MV_POLES.NETWORK_INFO.33KV_FEEDER_NAME' | translate}}</div>
            <div class="col-7">{{ (hasCimDataIntegration ? selectedMvPole.incomingAcLineName : selectedMvPole.feeder33Name) | hasValue}}</div>
        </div>
        <div class="row">
            <div class="col-5">{{'MV_POLES.NETWORK_INFO.INJ_SS_NAME' | translate}}</div>
            <div class="col-7">{{ (hasCimDataIntegration ? selectedMvPole.substationName : selectedMvPole.injectionSubstation) | hasValue}}</div>
        </div>
        <div class="row">
            <div class="col-5">{{'MV_POLES.NETWORK_INFO.11KV_FEEDER_NAME' | translate}}</div>
            <div class="col-7">{{ (hasCimDataIntegration ? selectedMvPole.acLineName : selectedMvPole.feeder11Name) | hasValue}}</div>
        </div>
        <div class="row">
            <div class="col-5">{{'COMMON.BU.SINGLE' | translate}}</div>
            <div class="col-7">{{ (hasCimDataIntegration ? selectedMvPole.geographicalRegionName : selectedMvPole.region) | hasValue}}</div>
        </div>
        <div class="row">
            <div class="col-5">{{'COMMON.UT.SINGLE' | translate}}</div>
            <div class="col-7">{{ (hasCimDataIntegration ? selectedMvPole.subGeographicalRegionName : selectedMvPole.district) | hasValue}}</div>
        </div>

      <div class="row">
        <div class="col-5">
          <p class="card-title">{{'MV_POLES.DEVICES.MV_DEVICES' | translate}}</p>
        </div>
        <div class="col-7">
          <div class="line-2"></div>
        </div>
      </div>
      <div class="row">
          <div class="col-5">{{'MV_POLES.DEVICES.INSULATORS' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.insulators | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'MV_POLES.DEVICES.GROUNDING_SYSTEM' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.groundingSystem | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'MV_POLES.EDIT.CROSS_ARM' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.crossArm | hasValue}}</div>
      </div>
      <div class="row">
          <div class="col-5">{{'MV_POLES.DEVICES.STAY_WIRE' | translate}}</div>
          <div class="col-7">{{ selectedMvPole.stayWire | hasValue}}</div>
      </div>
    </div>

    <div class="image-container main-col">

      <div class="card container">
        <div>{{'COMMON.PICTURES.TAG_MOUNTED' | translate}}</div>
        <div class="images-list single-image-list">
         <app-image-section
            [image]="getMountedTagImage()"
            [index]="0"
            [imageType]="ImageType.MountedTag"
            [editEnabled]="editEnabled"
            [inputId]="'fileMounted' + 0"
            [permission]="permissionsService.isMVPoleCreateEditAllowed"
            (imageClick)="showImage(ImageType.MountedTag)"
            (fileChange)="fileBrowserHandler($event)">
          </app-image-section>
        </div>
      </div>

      <div class="card container">
        <div>{{'COMMON.PICTURES.MV_CROSS_ARM' | translate}}</div>
        <div class="images-list single-image-list">
          <app-image-section
            [image]="getMvPoleCrossArmImage()"
            [index]="0"
            [imageType]="ImageType.MvPoleCrossArm"
            [editEnabled]="editEnabled"
            [inputId]="'fileMvPoleCrossArm' + 0"
            [permission]="permissionsService.isMVPoleCreateEditAllowed"
            (imageClick)="showImage(ImageType.MvPoleCrossArm)"
            (fileChange)="fileBrowserHandler($event)">
          </app-image-section>
        </div>
      </div>

      <div class="card container">
        <div>{{'COMMON.PICTURES.MV_POLE_LEFT' | translate}}</div>
        <div class="images-list single-image-list">
          <app-image-section
            [image]="getMvPoleLeftImage()"
            [index]="0"
            [imageType]="ImageType.MVPoleLeft"
            [editEnabled]="editEnabled"
            [inputId]="'fileLeftMvPole' + 0"
            [permission]="permissionsService.isMVPoleCreateEditAllowed"
            (imageClick)="showImage(ImageType.MVPoleLeft)"
            (fileChange)="fileBrowserHandler($event)">
          </app-image-section>
        </div>
      </div>

      <div class="card container">
        <div>{{'COMMON.PICTURES.MV_POLE_RIGHT' | translate}}</div>
        <div class="images-list single-image-list">
           <app-image-section
            [image]="getMvPoleRightImage()"
            [index]="0"
            [imageType]="ImageType.MVPoleRight"
            [editEnabled]="editEnabled"
            [inputId]="'fileMvPoleRight' + 0"
            [permission]="permissionsService.isMVPoleCreateEditAllowed"
            (imageClick)="showImage(ImageType.MVPoleRight)"
            (fileChange)="fileBrowserHandler($event)">
          </app-image-section>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" #closeAddModal class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isMapVisible" [longitude]="longitude" [latitude]="latitude">
        </app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage" [thumbImage]="selectedImage"
            [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">
            &lt;
          </button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">
            &gt;
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <div class="modal-body">
        <app-data-quality assetType="MvPole" [assetId]="selectedMvPole.id"
          [areaId]="selectedMvPole.districtId"></app-data-quality>
      </div>
    </div>
  </div>
</div>

<app-history (update)="updateHistory($event)"></app-history>

<div class="modal" id="auditReview" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.FIELD_AUDIT' | translate}}</h5>
        <button type="button" #closeAudit class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <app-audit-review (closeModal)="cancel()" assetType="MvPole" [assetId]="selectedMvPole.id"
        [areaId]="selectedMvPole.districtId"></app-audit-review>
    </div>
  </div>
</div>

<div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true"
  (hidden.bs.modal)="onModalAssignFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="assetAssignType == AssetAssignType.Assigned" class="modal-title">{{'COMMON.ASSIGN_AGENT' | translate}}</h5>
        <h5 *ngIf="assetAssignType == AssetAssignType.Retagged" class="modal-title">{{'COMMON.RETAG_TASK' | translate}}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <div class="modal-body">
        <div class="form-floating form-item">
          <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
            class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
            (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
          <label for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

          <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
            <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
              *ngFor="let u of mobileUsers">
              {{ u.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="assignTask()">
          <span *ngIf="assetAssignType == AssetAssignType.Assigned">{{'COMMON.ASSIGN_TASK' | translate}}</span>
          <span *ngIf="assetAssignType == AssetAssignType.Retagged">{{'COMMON.RETAG_TASK' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>